















import { Component, Vue, Prop } from 'vue-property-decorator';
import { qcItemLogs } from '@/api/task/crowd';
@Component
export default class inspectExpand extends Vue {
  @Prop() private row!: any;
  private dataList: object[] = [];
  private taskType: object = {
    1: '打点计数',
    2: '标注任务',
    3: '文字转写',
    4: '快判任务',
    5: '审核任务',
    6: '质检任务',
    7: '平台任务',
    8: '采集任务',
    9: '筛选任务',
    10: '审核任务',
  };
  private columnsSchema: object[] = [
    { title: '任务名称', key: 'title' },
    { title: '任务类型', align: 'center', slot: 'type' },
    { title: '做题人ID', key: 'lock_user', align: 'center' },
    { title: '团队ID', key: 'lock_team', align: 'center' },
    { title: '做题时间', align: 'center', slot: 'time' },
    { title: '审核结果', key: 'audit_status_name', align: 'center' },
  ];
  private created() {
    this.getList();
  }
  private async getList() {
    let res: any = await qcItemLogs({
      mlid: this.row.id,
      page: 1,
      pageSize: 20,
    });
    this.$nextTick(() => {
      this.dataList = res.rows;
    });
  }
  // 时间格式转化
  public formatTime(time: any) {
    if (time < 60) {
      return `0分${time}秒`;
    }
    let s = parseInt((time % 60).toString()); // 秒
    let m = parseInt((time / 60).toString()); // 分
    if (m > 60) {
      var h = parseInt((m / 60).toString()); // 小时
      m = parseInt((m % 60).toString());
    }
    if (h) {
      if (m) {
        return `${h}时${m}分${s}秒`;
      } else {
        return `${h}时0分${s}秒`;
      }
    }
    if (m) {
      return `${m}分${s}秒`;
    } else {
      return `0分${s}秒`;
    }
    return;
  }
}
